// angular
import { NgModule, ModuleWithProviders, inject } from "@angular/core";

// module
import { CORE_DIRECTIVES } from "./directives/index";
import { CORE_PROVIDERS } from "./services/index";

/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */

@NgModule({
  imports: [CORE_DIRECTIVES],
  providers: [...CORE_PROVIDERS]
})
export class CoreModule {
  // configuredProviders: *required to configure WindowService and ConsoleService per platform
  static forRoot(configuredProviders: Array<any>): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: configuredProviders
    };
  }
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error("CoreModule already loaded; Import in root module only.");
    }
  }
}
